function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolderClientOpen = function SvgFolderClientOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m19 20h-15c-1.11 0-2-.9-2-2v-12c0-1.11.89-2 2-2h6l2 2h7c1.097 0 2 .903 2 2h-17v10l2.14-8h17.07l-2.28 8.5c-.23.87-1.01 1.5-1.93 1.5z",
    fill: "#e57373",
    style: {
      fill: "#039be5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.985 18.967h-2.4661v-4.3157h2.4661m.61652-1.233h-3.6992a.61653 .61653 0 0 0 -.61652 .61653v6.1653a.61653 .61653 0 0 0 .61652 .61653h3.6992a.61653 .61653 0 0 0 .61653 -.61653v-6.1653a.61653 .61653 0 0 0 -.61653 -.61653m-11.714-1.2331h11.097v-1.2331h-11.097a1.2331 1.2331 0 0 0 -1.2331 1.2331v6.7818h-1.233v1.8496h8.6314v-1.8496h-6.1653z",
    style: {
      fill: "#b3e5fc",
      strokeWidth: 0.61653
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderClientOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-client-open.3302c36d.svg";
export { ForwardRef as ReactComponent };